/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Shared_DateFormats {
    DDMMYYYY = 10,
    MMDDYYYY = 20,
    YYYYDDMM = 30,
    YYYYMMDD = 40,
}
